import { render, staticRenderFns } from "./xiangqingye.vue?vue&type=template&id=1475f5c1&scoped=true"
import script from "./xiangqingye.vue?vue&type=script&lang=js"
export * from "./xiangqingye.vue?vue&type=script&lang=js"
import style0 from "./xiangqingye.vue?vue&type=style&index=0&id=1475f5c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1475f5c1",
  null
  
)

export default component.exports